import { Component } from 'react';
import DrawStage from './draw-stage';
import { CharacterCase, CharacterType } from 'types/enums';

class DrawStageContainer extends Component<any> {
  needsTallCanvas() {
    return (
      this.props.characterType === CharacterType.CURSIVE &&
      (this.props.character === 'J' ||
        this.props.character === 'Y' ||
        this.props.character === 'Z')
    );
  }

  needsWideCanvas() {
    return (
      this.props.characterType === CharacterType.CURSIVE &&
      (this.props.character === 'M' ||
        this.props.character === 'V' ||
        this.props.character === 'W' ||
        this.props.character === 'm')
    );
  }

  render() {
    return (
      <div
        className='draw-stage-container'
        style={{
          transform: `scale(${this.props.zoomLevel / 100.0})`,
          transformOrigin: `${100.0 - this.props.zoomLevel}% ${
            50.0 - this.props.zoomLevel / 2
          }% 0px`,
        }}
      >
        <h1
          className={`${this.props.characterType} ${
            this.props.character === 'Ñ' ? 'spanish-n' : ''
          }`}
        >
          {this.props.character}
        </h1>
        <DrawStage
          character={this.props.character}
          characterCase={this.props.characterCase}
          characterType={this.props.characterType}
          svgPath={this.props.svgPath}
          tall={this.needsTallCanvas()}
          wide={this.needsWideCanvas()}
          lowercase={
            this.props.characterCase === CharacterCase.LOWERCASE &&
            !this.needsWideCanvas()
          }
          showBackground={this.props.showBackground}
          showLines={this.props.showLines}
          currentPathIndex={this.props.currentPathIndex}
          spanishN={this.props.character === 'Ñ'}
          drawFinished={this.props.drawFinished}
          languageId={this.props.languageId}
          zoomLevel={this.props.zoomLevel}
          textSize={this.props.textSize}
          audioLoading={this.props.audioLoading}
          gameStarted={this.props.gameStarted}
          volume={this.props.volume}
          muted={this.props.muted}
          onSetNextPathIndex={this.props.onSetNextPathIndex}
          onToggleDrawInProgress={this.props.onToggleDrawInProgress}
          onToggleDrawFinished={this.props.onToggleDrawFinished}
          onAudioDownloadRequest={this.props.onAudioDownloadRequest}
          onAudioDownloadResponse={this.props.onAudioDownloadResponse}
        />
      </div>
    );
  }
}

export default DrawStageContainer;
